(function(angular) {
    const isUrlDebugModeConfigured = (() => {
        try {
            return (new URL(location.href)).searchParams.has('debug');
        } catch (error) {
            return false;
        }
    })();

    angular.module('wtApp.dataService')
        .decorator('$rootScope', function($delegate) {
            const $broadcast = $delegate.constructor.prototype.$broadcast;
            const $emit = $delegate.constructor.prototype.$emit;

            $delegate.constructor.prototype.$broadcast = function() {
                if (isUrlDebugModeConfigured) {
                    console.debug('$broadcast ' + this.$id + ' with arguments:', arguments);
                }

                return $broadcast.apply(this, arguments);
            };

            $delegate.constructor.prototype.$emit = function() {
                if (isUrlDebugModeConfigured) {
                    console.debug('$emit ' + this.$id + ' with arguments:', arguments);
                }

                return $emit.apply(this, arguments);
            };

            return $delegate;
        });
})(window.angular);
